import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getNivFor() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-NivFor`);
    return response

  } catch (error) {
    console.error('Error al obtener el nivel de formación del usuario', error);
  }
}